<h2 class="h2">New Campaign</h2>

<p style="font-size: 15px; line-height: 1.4; margin-bottom: 1.25rem;">
  Campaigns are a way to organize your work and see what is most important to
  you right now. Assessments and info are only applied to people in a
  campaign context.
</p>

<form class="vert-0100" id="campaignCreateForm" (ngSubmit)="createCampaign()">

  <app-error-notification [errors]="errorMessages"></app-error-notification>

  <mat-form-field class="col__">
    <mat-label>Campaign Name</mat-label>
    <input matInput id="campaign-name" name="campaign-name" placeholder="" data-test-id="campaignNameInput" type="text" maxlength="50"
      [(ngModel)]="input.name" />
  </mat-form-field>

  <button type="submit" [disabled]="isSubmitting" class="btn floatRight" data-test-id="createCampaignButton">Create Campaign</button>

</form>
